import { ChildAvailabilityItem, ChildDetails } from './child.ts';
import { ChildGenderEnum } from './childUtilityInterfaces.ts';
import { BeneficiaryAvailabilityState } from './hold.ts';

export const mockChildDetails: ChildDetails = {
  ageInYearsAndMonths: '19',
  birthDate: '2011-08-30 00:00:00',
  chronicIllness: [],
  cluster: null,
  cognitiveAgeGroup: '9-11',
  community: null,
  compassId: '3241524',
  correspondenceLanguage: 'English',
  country: 'Brazil',
  education: {
    academicPerformance: 'Above Average',
    formalLevel: 'Not Enrolled',
    gradeLevel: { local: 'Middle 6', us: 'University Level 2' },
    majorOrCourseOfStudy: null,
    notEnrolledInEducationReason: 'flooding',
  },
  fieldOffice: null,
  fundType: 'Sponsorship',
  gender: ChildGenderEnum.Male,
  globalId: '06588026',
  hangul: {
    name: 'Breiner 호세 Escandon Puentes',
    preferred: '호세',
  },
  householdDuty: [
    'Carries Water',
    'Running Errands',
    'No Household Duties - Too Young',
  ],
  icp: { country: '', id: '' },
  imageUrl:
    'https://media.ci.org/w_150/v1725986904/ChildPhotos/Published/10432941_lncgbi.jpg',
  interests: {
    christianActivityName: ['Sunday School/Church', 'Bible Class'],
    favoriteProjectActivity: [
      'Learning about God',
      'Playing Sports',
      'Listening to Bible Stories',
    ],
    favoriteSchoolSubject: ['Math'],
    thingsILike: ['Sports', 'Singing'],
  },
  isInHivAffectedArea: false,
  isBirthDateEstimated: true,
  isOrphan: false,
  isSpecialNeeds: false,
  lastPhotoDate: '2023-05-11 00:00:00',
  lastReviewDate: '2023-06-06 00:00:00',
  localId: 'CO078100181',
  localNumber: '0181',
  name: { first: 'Breiner', preferred: 'Jose' },
  physicalDisability: [],
  plannedCompletion: {
    date: '2033-08-30 00:00:00',
    dateChangeReason: null,
  },
  primaryCaregiver: { name: 'Tibisays Puentes' },
  programDeliveryType: 'Center Based',
  recordType: 'Sponsorship Child',
  reviewStatus: 'Approved',
  sourceKit: 'BeneficiaryKit',
  sponsorshipStatus: 'Sponsored',
  state: 'Active',
  status: 'Active',
  vocationalTrainingType: 'Not enrolled',
  householdList: [
    {
      femaleGuardian: {
        employmentStatus: 'Sometimes Employed',
        occupation: 'Waiter / Food Server',
      },
      household: { id: 'H-04098170', name: 'CO781-Escandon-0181' },
      householdMemberList: [
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Mother',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Sister',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Father',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Sister',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Sister',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Brother',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Non-relative',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Foster Parent',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Step-father',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
        {
          globalId: null,
          localId: null,
          householdMemberName: 'Tibisays Puentes',
          householdMemberRole: 'Step-mother',
          isCaregiver: true,
          isPrimaryCaregiver: true,
        },
      ],
      maleGuardian: {
        employmentStatus: 'Not Employed',
        occupation: 'Agriculture / Farmer',
      },
      parents: {
        naturalFather: { isAlive: 'No', isLivingWithChild: false },
        naturalMother: { isAlive: 'Yes', isLivingWithChild: true },
        maritalStatus: 'Were Married, Now Divorced Or Permanently Separated',
        together: 'No',
      },
      siblings: {
        numberOfBrothers: 2,
        numberOfSiblingChildren: 5,
        numberOfSisters: 3,
      },
      youthHeadedHousehold: false,
      revisedValues: 'RevisedValuesToUpdate',
      sourceKit: 'HouseholdKit',
    },
  ],
};

export const mockChildAvailability: ChildAvailabilityItem = {
  age: 10,
  birthDate: '2013-02-23',
  holdExpirationDate: null,
  fieldOffice: 'PE',
  gender: ChildGenderEnum.Female,
  globalId: '09549200',
  holdingGlobalPartnerId: null,
  icp: {
    country: 'Peru',
    id: 'PE0644',
    // name: 'Iglesia Cristiana Evangélica en la Roca - El Auque',
  },
  imageUrl:
    'https://media.ci.org/w_150/v1692289081/ChildPhotos/Published/09549200_gxuhss.jpg',
  isInHivAffectedArea: false,
  isOrphan: false,
  isSpecialNeeds: false,
  localId: 'PE064400131',
  minDaysWaiting: 358,
  name: { first: 'Erika Mardeli', preferred: 'Erika' },
  priorityScore: 462,
  state: BeneficiaryAvailabilityState.Available,
  sourceCode: null,
  waitingSinceDate: '2023-01-31',
};
